module.exports = __webpack_public_path__ + "static/media/019.ecf3385b.jpg";